'use strict';

var Params = function Params(yAxisShift) {
  return function (containerWidth, containerHeight) {
    var padding = {
      top: 10,
      bottom: 60,
      left: 40,
      right: 0
    };
    var width = containerWidth - (padding.left + padding.right);
    var height = containerHeight - (padding.top + padding.bottom);
    return {
      width: width,
      height: height,
      containerWidth: containerWidth,
      containerHeight: containerHeight,
      padding: padding,
      yNumberOfTicks: 10,
      xAxisShift: 35,
      yAxisShift: yAxisShift,
      yAxisLabelShift: 50,
      xAxisLabelShift: -50,
      forceWidth: true
    };
  };
};
module.exports = Params;